<template>

    <!--<div class="top-tab" v-if="tabList&&tabList.length">-->
      <!--<div class="tab-item" :class="idx==index?'tab-check':''" v-for="(item,idx) in tabList" @click="choose(item,idx)">-->
        <!--<div class="tab-text">{{item.name}}</div>-->
        <!--<div class="tab-num" v-if="item.num!=-1">{{item.num}}</div>-->
        <!--<div class="tab-num" v-if="item.num==-1">...</div>-->
      <!--</div>-->
    <!--</div>-->
  <div class="top-tab" v-if="tabList&&tabList.length">
    <div class="tab-item " :class="idx==index?'active':''" v-for="(item,idx) in tabList" @click="choose(item,idx)">
      <span>{{item.name}}</span>
      <span v-if="item.num!=-1" class="tab-num">{{item.num}}</span>
      <span v-else  class="tab-num">...</span>
    </div>
  </div>
  <!--<a-tabs v-model:activeKey="index"  v-if="tabList&&tabList.length" @change="choose(item,idx)">-->
    <!--<a-tab-pane :key="idx"  v-for="(item,idx) in tabList" >-->
      <!--{{item.name}}<span v-if="item.num!=-1">{{item.num}}</span>-->
      <!--<span v-else>...</span>-->
    <!--</a-tab-pane>-->
  <!--</a-tabs>-->
</template>

<script>


  export default {
    name: 'TopTabNew',
    props: {
      tabList: {
        type: Array,
        default: []
      },
      index:{
        type:Number,
        default:0
      }
    },methods:{
      choose(item,idx){
        // if(idx==this.index){
        //   return;
        // }
        this.$emit("search",item.type,idx);
      }
    }
  }
</script>
<style lang="less" scoped>
  .top-tab{
    display: flex;
    border-bottom: 1px solid rgba(228, 230, 232, 1);
    font-size: 16px;
  }

  .tab-item{
    margin-right: 48px;
    color: rgba(125, 133, 146, 1);
    cursor: pointer;
  }

  .tab-item .tab-num{
    color: rgba(10, 22, 41, 1);
    margin-left: 5px;
    font-weight: 600;
  }
  .tab-item.active .tab-num{
    color: rgba(246, 81, 96, 1) !important;
  }


  .tab-item.active::after {
    content: '';
    width: 48px;
    height: 4px;
    display: block;
    margin: 0 auto;
    border-radius: 2px;
    background: rgba(63, 140, 255, 1);
    margin-top: 10px;
  }
</style>